import { render, staticRenderFns } from "./ThemeCreationPage.vue?vue&type=template&id=bb5f3b70&"
import script from "./ThemeCreationPage.vue?vue&type=script&lang=ts&"
export * from "./ThemeCreationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports